/**
 * The blackjack band's first line — the clock, the dealer, the result — in poker's
 * `.td-clock` (Phase 3's `BandClock`), so the band reads the same at both tables.
 *
 * Shared by the route and the harness, so the two cannot drift.
 */
import type { BjSnapshot } from "./blackjack-director";
import type { BjView } from "./blackjack-view";

export function BjClockLine({ snap, view, names, dealerName, result }: {
  snap: Pick<BjSnapshot, "phase" | "awaiting" | "waiting" | "heroClock"> | null;
  view: BjView | null;
  names: readonly string[];
  dealerName: string;
  /** The hand's one line once it is over ("20 — held up against 18"). */
  result?: string | null;
}) {
  if (!snap || !view) return null;
  if (result && snap.phase === "between") {
    return <div className="td-clock td-clock-win" role="status"><span>{result}</span></div>;
  }
  if (snap.waiting) {
    return (
      <div className="td-clock" role="status">
        <span>Waiting for {names[snap.waiting.seat] ?? "…"}…</span>
        <span className="num">{snap.waiting.secondsLeft} s</span>
      </div>
    );
  }
  if (snap.heroClock) {
    const ask = snap.awaiting === "insurance" ? "Insurance?" : "Your move";
    return (
      <div className={"td-clock" + (snap.heroClock.hurry ? " td-clock-hurry" : "")} role="status">
        <span>{snap.heroClock.hurry ? "Hurry up" : ask}</span>
        <span className="num">{snap.heroClock.secondsLeft} s</span>
      </div>
    );
  }
  if (view.phase === "dealer") return <div className="td-clock td-clock-quiet" role="status"><span>{dealerName} plays</span></div>;
  if (snap.phase === "playing") return <div className="td-clock td-clock-quiet" role="status"><span>Dealing…</span></div>;
  if (snap.phase === "between") return <div className="td-clock td-clock-quiet" role="status"><span>Hand over</span></div>;
  return <div className="td-clock td-clock-quiet" role="status"><span>Place your bet</span></div>;
}
